"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = RatingAndPrice;

var _react = _interopRequireDefault(require("react"));

var _reactRater = _interopRequireDefault(require("react-rater"));

require("react-rater/lib/react-rater.css");

var _ShowReviews = _interopRequireDefault(require("../ShowReviews"));

RatingAndPrice.defaultProps = {
  numReviews: 0,
  numRatings: 0
};

function RatingAndPrice(props) {
  var numRatings = props.numRatings,
      numReviews = props.numReviews,
      price = props.price,
      pricePrefix = props.pricePrefix;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
    className: "review-count"
  }, _react["default"].createElement("div", {
    className: "star"
  }, _react["default"].createElement(_reactRater["default"], {
    total: 5,
    interactive: false,
    rating: numRatings ? Number(numRatings) : 0
  })), _react["default"].createElement(_ShowReviews["default"], {
    numReviews: numReviews
  })), price && _react["default"].createElement("div", {
    className: "price"
  }, _react["default"].createElement("span", null, pricePrefix), _react["default"].createElement("p", null, price.currency, " ", Math.ceil(price.amount).toLocaleString())));
}